<template>
  <div class="content">
      <div class="search-area">
                <div class="w100f t-left mb15"><b>选择需要导入的数据</b></div>
                <div class="import-a-sty">
                    <a @click="toLink('/importSalesData')">近三年销售数据导入</a><label> | </label>
                    <a  class="fontC-4fa1a4" @click="toLink('/importFreightQuotation')">运费报价导入</a> <label> | </label>
                    <a @click="toLink('/importWarehouseQuotation')">仓储报价导入</a> 
                </div>
      </div> 
      <div class="search-area mt15">
            <div class="import-sty">
                    <!-- <el-steps :active="active" align-center>
                      <el-step title="上传文件"></el-step>
                      <el-step title="确认数据"></el-step>
                      <el-step title="导入完成"></el-step> 
                    </el-steps> -->
                    <div v-if="active == 0">
                          <div class="ml71"> 
                                <div class="mt15 mt50">下载模板：<el-button plain size="medium" @click="uploadExcel">下载文件模板</el-button></div>
                                <div class="mt15 mt15 h120"><p class="fl">导入文件：</p>
                                <!-- <el-button size="medium" type="info" @click="add(1, '')">点击上传文件</el-button> -->
                                      <el-upload
                                        class="upload-demo fl"
                                        action="#"  
                                        :before-upload="beforeUpload"
                                        multiple
                                        :limit="1"
                                        accept=".xlsx,.xsl,.xls,.xlsm"
                                        :auto-upload="false"
                                        :on-change="changeFile"
                                        :on-exceed="handleExceed">
                                        <el-button size="medium" type="info" v-loading.fullscreen.lock="fullscreenLoading">点击上传文件</el-button>
                                        <div slot="tip" class="el-upload__tip">
                                        当前仅支持 excel 格式文件（大小在5M以内），请使用 Office 2010 及以上版本，否则可能出现乱码<br>
                                        必须严格按照模板内容填入数据，否则可能会出现导入异常
                                        </div>
                                      </el-upload>
                                </div> 
                          </div> 
                          <!-- <div class="mt15 t-right"> 
                                <el-button size="medium" type="info" @click="next()">下一步</el-button>
                          </div>  -->
                    </div> 
                    </div>
                    <div v-if="active == 1" class="mt15">
                          <div class="summary-sty">
                          预计导入<b class="fontC-4fa1a4"> {{totalRows}} </b>条数据，其中<b class="fontC-4fa1a4"> {{errorRows}}  </b>条可能有误，请调整后再导入
                          <a class="txt-color-blue ml10" @click="getDataAll()">全部数据 | </a>
                          <a class="txt-color-blue" @click="getDataErrorFlagY()">只看错误数据 | </a>
                          <a class="txt-color-blue" @click="getDataErrorFlagN()">只看准确数据</a> 
                          </div>
                          <el-table :data="tableData" border style="width: 100%;" v-loading="loading">
                            <el-table-column label="序号" width="60" header-align="center" align="center">
                              <template slot-scope="scope">
                                <!-- {{ scope.$index + 1 }} -->
                                {{(page.pageIndex - 1) * page.pageSize + scope.$index + 1}}
                              </template>
                            </el-table-column> 
                            <el-table-column prop="colA" label="销售日期" header-align="center" align="center" width="250">
                                 <template slot-scope="scope">
                                      <el-date-picker
                                        v-model="scope.row.colA"
                                        type="date"
                                        class="w180" 
                                        placeholder="选择日期">
                                      </el-date-picker>
                                 </template>
                            </el-table-column>
                            <el-table-column prop="colB" label="省" header-align="center" align="center" width="200">
                                <template slot-scope="scope">
                                      <el-select v-model="scope.row.colB" placeholder="请选择" @change="province(scope.row.colB)" filterable>
                                              <el-option
                                                v-for="item in provinceList"
                                                :key="item.label"
                                                :label="item.label"
                                                :value="item.label">
                                              </el-option>
                                      </el-select>
                                 </template>
                            </el-table-column>
                            <el-table-column prop="colC" label="市" header-align="center" align="center" width="200">
                                <template slot-scope="scope">
                                      <el-select v-model="scope.row.colC" placeholder="请选择" @change="city(scope.row.colC)">
                                              <el-option
                                                v-for="item in cityList"
                                                :key="item.label"
                                                :label="item.label"
                                                :value="item.label">
                                              </el-option>
                                      </el-select>
                                 </template>
                            </el-table-column>
                            <el-table-column prop="colD" label="区/县" header-align="center" align="center" width="250">
                                <template slot-scope="scope">
                                      <el-select v-model="scope.row.colD" placeholder="请选择">
                                              <el-option
                                                v-for="item in districtList"
                                                :key="item.label"
                                                :label="item.label"
                                                :value="item.label">
                                              </el-option>
                                      </el-select>
                                 </template>
                            </el-table-column>
                            <el-table-column prop="colE" label="商业公司名称" header-align="center" align="center" show-overflow-tooltip width="150"></el-table-column>
                            <el-table-column prop="colF" label="购入终端" header-align="center" align="center" show-overflow-tooltip width="150"></el-table-column> 
                            <el-table-column prop="colG" label="产品编号" header-align="center" align="center" show-overflow-tooltip width="150"></el-table-column>
                            <el-table-column prop="colH" label="产品名称" header-align="center" align="center" show-overflow-tooltip width="150"></el-table-column>
                            <el-table-column prop="colI" label="规格" header-align="center" align="center" show-overflow-tooltip width="150"></el-table-column>
                            <el-table-column prop="colJ" label="生产企业" header-align="center" align="center" show-overflow-tooltip width="150"></el-table-column>
                            <el-table-column prop="colK" label="产品单价" header-align="center" align="center" width="100"></el-table-column>
                            <el-table-column prop="colL" label="数量" header-align="center" align="center" width="100"></el-table-column>
                            <el-table-column prop="colM" label="核算单价" header-align="center" align="center" width="100"></el-table-column>
                            <el-table-column prop="errorInfo" label="错误信息" header-align="center" align="center" fixed="right" width="150" show-overflow-tooltip>
                                  <template slot-scope="scope">
                                    {{scope.row.errorInfo | errorInfo}}
                                  </template>
                            </el-table-column>
                            <el-table-column label="操作" header-align="center" align="center" fixed="right" width="150">
                              <template slot-scope="scope">
                                <a class="txt-color" @click="save(scope.row)">保存 | </a>
                                <a class="txt-color-red" @click="deletes(scope.row.guid)">删除</a> 
                              </template>
                            </el-table-column>
                          </el-table>
                          <el-pagination
                          class="pt pb back-color-fff"
                           style="padding: 16px;" 
                          background
                          @size-change="handleSizeChange"
                          @current-change="handleCurrentChange"
                          :page-sizes="[10, 100, 200]"
                          :current-page="page.pageIndex"
                          :page-size="page.pageSize"
                          layout="total, sizes, prev, pager, next, jumper"
                          :total="page.totalRows">
                        </el-pagination> 
                          <div class="mt15 t-right">
                                <el-button size="medium" plain @click="active=0">取消</el-button>
                                <el-button size="medium" type="info" @click="nextImport()" v-loading.fullscreen.lock="fullscreenLoading">导入</el-button>
                          </div>
                        </div>
                        
                        <div class="font-S16 mt50 h150" v-if="active == 2">
                                <img width="64" height="64" src="../../assets/images/right.png"><br><br>
                                导入成功，本次共导入<b class="fontC-4fa1a4">{{importSum}}</b>条数据
                        </div>

            </div>
      </div> 
  </div>
</template>

<script>
import {route}  from '@/api/apiRoute';
import store from '@/store';
import areaJson from '../../assets/js/china_address_v4.js';
export default {
  data() {
    return { 
      url:`/${serverConfig.msCommonAdminCloudService}/warehouse-select/import-landtransquoteprice?tenantGuid=`+this.$store.state.guid,
      active: 0, 
      page: {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        importType: '0001',
        errorFlag: '', 
      },
      importSum:0,
      loading:true,
      tableData:[],
      provinceList:areaJson,
      cityList:[],
      districtList:[],
      guids:[],
      errorRows:0,
      totalRows:0,
      fullscreenLoading: false
    };
  },
  created() {  
    // this.src = '';
    // this.getSrc();  
  },   
  watch: {  
  },
  mounted(){    
  
  }, 
  methods: {
    toLink(link){
          this.$router.push({path: link})
    },
    province(pr){
        let self= this; 
        self.cityList = [];
        self.provinceList.forEach(function(i){
            if(i.label == pr){
                  if(i.children != null && i.children != ''){
                        i.children.forEach(function(j){ 
                                  self.cityList.push(j); 
                        })
                  } 
            }
        })
    },
    city(ci){
        let self= this;
        console.log(self.cityList);
        self.districtList = [];
        self.cityList.forEach(function(i){
            if(i.label == ci){
                  if(i.children != null && i.children != ''){
                          i.children.forEach(function(j){ 
                                    self.districtList.push(j); 
                          })
                  }
            }
        })
    },
        uploadExcel(){ 
              window.open('/销售流向_最终系统导入版.xlsx');
        },
       beforeUpload(file) {
            let filename = file.name
            let arr = filename.split('.')
            if (arr[1] !== 'xls' && arr[1] !== 'xlsx'&& arr[1] !== 'xlsm') {
              this.$message.error('上传文件只能是 excel/xls 格式!')
              return false
            }
            return arr
      }, 
      handleExceed(files, fileList) {
        this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
      },
      changeFile(file,fileList) {
           let self = this; 
           let isLt5M = file.size / 1024 / 1024 < 5
           if (!isLt5M) {
                  self.$message.error('上传文件大小不能超过 5MB')
                  file = null
                  fileList = [];
                  self.$refs.upload.clearFiles() // 清除前端显示的文件列表
            }else{
                  self.fullscreenLoading = true;
                  let formData = new FormData();
                  formData.append('file',file.raw);//传文件
                  self.api.postFile(self.url,formData).then(function(res){  
                    if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                      self.$message({
                        type: 'success',
                        message: '上传成功'
                      })  
                      self.fullscreenLoading = false;
                    } else {
                      self.$message({
                        type: 'warning',
                        message: '数据格式不正确！'
                      })
                      self.fullscreenLoading = false;
                      return false
                    }
                  })
            } 
      },
      next(){
             let self = this;
             self.active = 1;
             self.getData(true);
      },
      getDataAll(){
             let self = this;
             self.page.errorFlag = '';
             self.getData(true);
      },
      getDataErrorFlagY(){
             let self = this;
             self.page.errorFlag = 'Y';
             self.getData(true);
      },
      getDataErrorFlagN(){
             let self = this;
             self.page.errorFlag = 'N';
             self.getData(true);
      },
      getData(flg) {
            let self = this;
            if (flg) {
              self.page.pageIndex = 1;
            } 
            self.tableData = [];
            self.loading = true;
            self.api.postJson('/ms-user-scm-service/import-data/get-import-intermediate-data', self.page).then(res => { 
              if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                self.tableData = res.data.data.details.records; 
                self.errorRows = res.data.data.errorRows;
                self.totalRows = res.data.data.totalRows; 
                self.page.totalPage = res.data.data.details.totalPages;
                self.page.totalRows = res.data.data.details.totalRows; 
                self.loading = false;
              } else {
                self.$message.error(res.data.msg);
                self.loading = false;
              }
            });
    },
    save(row){
            let self = this; 
            row.colA = self.$moment(row.colA).format('YYYY-MM-DD HH:mm:ss');
            if(row.colC == '市辖区' || row.colC == '县'){
                   row.colC = row.colB
            }
            self.loading = true;
            row.errorFlag = 'N';
            row.errorInfo = '';
            self.api.put('/ms-user-scm-service/import-data/update-intermediate-data',row).then(res => {
                    if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                          self.$message.success("保存成功");
                          self.getData(true); 
                    } else {
                          self.$message.error(res.data.msg);
                          self.loading = false;
                    }
            });
    },
    deletes(guid){
            let self = this;  
            self.guids = [];
            self.guids.push(guid);
            self.loading = true;
            self.api.postJson('/ms-user-scm-service/import-data/delete-intermediate-data', self.guids).then(res => {
                    if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                          self.$message.success("删除成功");
                          self.getData(true); 
                    } else {
                          self.$message.error(res.data.msg);
                          self.loading = false;
                    }
            });
    },
    nextImport(){
             let self = this;
             self.fullscreenLoading = true;
             self.api.postJson('/ms-user-scm-service/import-data/finish-sale-flow?tenantGuid='+self.$store.state.guid).then(res => {
              if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) { 
                self.importSum = res.data.data;
                self.$message.success("导入成功");
                self.active = 2;
                self.fullscreenLoading = false;
              } else {
                self.active = 1;
                self.$message.error(res.data.msg);
                self.fullscreenLoading = false;
                self.getData(true); 
              }
            });
    },
    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      self.getData(false);
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      self.getData(false);
    },


  },
};
</script>
<style  scoped>
/deep/ .el-step__icon.is-text {
    border-radius: 50%;
    border-color:#4fa1a4;
    border-color: inherit;
}
/deep/ .el-step__icon-inner {
    color: #4fa1a4;
}
/deep/ .el-step__title.is-process {
    color: #4fa1a4;
}
</style>